/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_TryInputs */

const en_dialog_premium_try = /** @type {(inputs: Dialog_Premium_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Premium`)
};

const es_dialog_premium_try = /** @type {(inputs: Dialog_Premium_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probar Premium`)
};

/**
* | output |
* | --- |
* | "Try Premium" |
*
* @param {Dialog_Premium_TryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_try = /** @type {((inputs?: Dialog_Premium_TryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_TryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_try(inputs)
	return en_dialog_premium_try(inputs)
});